// eslint-disable-next-line no-unused-vars
import mediumZoom from 'medium-zoom';

export default {
  init() {
  },
};

const zoomDefault = mediumZoom('[data-zoom="1"] img', {
  margin: 24,
  background: '#fff',
  scrollOffset: 0,
  container: '.medium-zoom__container-img',
  template: '#medium-zoom__template',
});

zoomDefault.on('opened', () => {
  const closeButton = document.querySelector('[data-zoom-close]')
  closeButton.addEventListener('click', () => zoomDefault.close())
})

// eslint-disable-next-line no-unused-vars
const observedZooms = [
  zoomDefault,
]



// WEBPACK FOOTER //
// ./scripts/routes/medium-zoom.js